<template>
    <div class="content">
        <br>
        <p>{{ infotext }}</p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"

    @Component({
        components: {
        }
    })
    export default class RadioPeittoalueet extends Vue {
        get infotext(): string | undefined {
            return this.$t("App.TVJaRadio.TVPeittoalueet.InfoText")
        }
    }
</script>
